import { createAsyncThunk } from '@reduxjs/toolkit';
import queryUserInfo from './services';

const fetchUserInfo = createAsyncThunk(
  'FETCH_USER_INFO',
  async () => queryUserInfo(),
);

export default fetchUserInfo;
